// extracted by mini-css-extract-plugin
export default {"container":"GRDB_container__+AULL","img":"GRDB_img__ykRvz","header":"GRDB_header__7wK43","description":"GRDB_description__qz3n1","description2":"GRDB_description2__za7x7"};